import { FORM_TOKENS_STORE_NAME } from '../../constants';
import { FormTokenMetaRecord, TokenId } from '../../types/context';
import { getFormTokenMetaKey } from './getFormTokenMetaKey';
import { openFormTokensDb } from './openFormTokensDb';

// Puts changed meta records and deletes removed ones in ONE transaction (all-or-nothing)
export const writeFormTokenMetaRecords = async (
  storageKey: string,
  changedRecords: FormTokenMetaRecord[],
  removedIds: TokenId[]
): Promise<boolean> => {
  if (changedRecords.length === 0 && removedIds.length === 0) {
    return true;
  }

  const db = await openFormTokensDb();
  if (!db) {
    return false;
  }

  return new Promise<boolean>((resolve) => {
    try {
      const transaction = db.transaction(FORM_TOKENS_STORE_NAME, 'readwrite');
      const store = transaction.objectStore(FORM_TOKENS_STORE_NAME);
      changedRecords.forEach((record) =>
        store.put(
          JSON.stringify(record),
          getFormTokenMetaKey(storageKey, record.id)
        )
      );
      removedIds.forEach((metaId) =>
        store.delete(getFormTokenMetaKey(storageKey, metaId))
      );
      transaction.oncomplete = () => resolve(true);
      transaction.onerror = () => resolve(false);
      transaction.onabort = () => resolve(false);
    } catch {
      resolve(false);
    }
  });
};
